import { Component, OnInit, Input } from '@angular/core';
import { IServiceFactory } from '../../../Services/service-factory';
import { IStudentLessonService } from '../../../Services/student-lesson-service';
import { Lesson } from '../../../Elearning-Models';

@Component({
  selector: 'app-zero-lessons',
  templateUrl: './zero-lessons.component.html',
  styleUrls: ['./zero-lessons.component.scss']
})
export class ZeroLessonsComponent implements OnInit {
  studentLessonService: IStudentLessonService;
  
  lesson: Lesson;

  receivedData: boolean = false;
  @Input() lessonID: number;
  constructor(private serviceFactory: IServiceFactory) { }

  ngOnInit(): void {
    this.getLessonFromService();
  }

  getLessonFromService(){
    this.studentLessonService = this.serviceFactory.getStudentLessonService();

    this.studentLessonService.lessonEmitter.subscribe( result => {
        this.onLessonAvailableUpdate(result);
  
    });
    this.studentLessonService.emitLesson(this.lessonID);
  }

  onLessonAvailableUpdate(lesson: Lesson){
    this.lesson = lesson;
    this.receivedData = true;
  }

  goToHomepage(){
    window.location.href="/Homepages/RightPath.aspx";
  }

}
